import router from './router'
// import store from './store'
// import { Message } from 'element-ui'
import { getToken } from '@/utils/auth' // get token from cookie
const whiteList = ['/login'] // no redirect whitelist

// 防止热更新时重复注册守卫
if (!router._hasPermissionGuard) {
  router.beforeEach(async(to, from, next) => {
    // 防止导航到相同路由
    if (to.path === from.path) {
      next()
      return
    }

    const hasToken = getToken()
    if (hasToken) {
      // 如果已登录，访问登录页则重定向到首页
      if (to.path === '/login') {
        next({ path: '/userCenter', replace: true })
      } else {
        next()
      }
    } else {
      // 如果未登录，检查是否在白名单中
      if (whiteList.indexOf(to.path) !== -1) {
        next()
      } else {
        // 重定向到登录页
        next(`/login?redirect=${encodeURIComponent(to.fullPath)}`)
      }
    }
  })
  router._hasPermissionGuard = true
}

router.afterEach(() => {
})
